function _ref4(res) {
  return "query" !== res.operation.operationName;
}

function _ref7() {
  return !1;
}

import { share, onPush, filter, map, merge } from "wonka";

var suspenseExchange = function(ref) {
  function _ref2(op) {
    if ("query" === op.operationName) {
      keys.add(op.key);
    }
  }
  function _ref3(op) {
    return "query" !== op.operationName || !isOperationCached(op);
  }
  function _ref5(res) {
    var ref = res.operation, key = ref.key;
    keys.delete(key);
    if (isResultImmediate(res)) {
      cache.delete(key);
    } else {
      cache.set(key, res);
    }
  }
  function _ref6(res) {
    return "query" === res.operation.operationName && !isOperationCached(res.operation);
  }
  function _ref8(op) {
    if ("query" === op.operationName) {
      keys.delete(op.key);
    }
  }
  function _ref9(op) {
    return "query" === op.operationName && !isOperationCached(op);
  }
  function _ref10(op) {
    var key = op.key, result = cache.get(key);
    cache.delete(key);
    keys.delete(key);
    return result;
  }
  function _ref11(op) {
    return "query" === op.operationName && isOperationCached(op);
  }
  var cache, keys, isOperationCached, isResultImmediate, client = ref.client, forward = ref.forward;
  if (!client.suspense) {
    if ("production" !== process.env.NODE_ENV) {
      console.warn("[@urql/exchange-suspense]: suspenseExchange is currently disabled.\nTo use the suspense exchange with urql the client needs to be put into suspense mode. You can do so by passing `suspense: true` when creating the client.");
    }
    return function _ref(ops$) {
      return forward(ops$);
    };
  }
  cache = new Map;
  keys = new Set;
  isOperationCached = function(operation) {
    return cache.has(operation.key);
  };
  isResultImmediate = function(result) {
    return keys.has(result.operation.key);
  };
  return function(ops$) {
    var sharedOps$ = share(ops$), forwardResults$ = share(forward(onPush(_ref2)(filter(_ref3)(sharedOps$)))), ignoredResults$ = filter(_ref4)(forwardResults$), deferredResults$ = onPush(_ref5)(filter(_ref6)(forwardResults$)), immediateResults$ = filter(_ref7)(onPush(_ref8)(filter(_ref9)(sharedOps$))), cachedResults$ = map(_ref10)(filter(_ref11)(sharedOps$));
    return merge([ ignoredResults$, deferredResults$, immediateResults$, cachedResults$ ]);
  };
};

export { suspenseExchange };
//# sourceMappingURL=urql-exchange-suspense.es.js.map
